import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import '@google/model-viewer';
import { ModelViewerArtefactoService } from '../model-viewer-artefacto.service';
import { ModelViewerElement } from '@google/model-viewer/lib/model-viewer';

/**
 * Ce module permet d'afficher un model 3d et de le manipuler
 * Il s'appuie aujourd'hui sur model-viewer de google
 */

@Component({
  selector: 'app-model-viewer-artefacto',
  templateUrl: './model-viewer-artefacto.component.html',
  styleUrl: './model-viewer-artefacto.component.scss',
})
export class ModelViewerArtefactoComponent
  implements OnInit, AfterViewInit, OnChanges
{
  @ViewChild('modelViewer')
  modelViewer?: ElementRef<ModelViewerElement>;

  // Artefacto specific
  @Input('width') width: string = '100%';
  @Input('height') height: string = '50rem';

  @Input('model-file-url') modelFilePath?: string | Blob | null;

  @Input('display-ar-button') hideArButton: boolean = true;

  @Output('model-loaded') modelLoaded: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output('can-activate-ar') canActivateAr: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Input('force-ar') forceAr: boolean = false;

  // For more attributes, see https://modelviewer.dev/docs/index.html

  // Errors messages
  public errorMessages: string[] = [];

  // Display only viewer when minimal data is given
  public enabled = false;

  constructor(
    private modelViewerArtefactoService: ModelViewerArtefactoService
  ) {}

  // The model-viewer component is loaded
  ngAfterViewInit(): void {
    this.modelViewer?.nativeElement.addEventListener('load', () => {
      this.onModel3dLoaded();
    });
    this.modelViewer?.nativeElement.addEventListener('progress', (e: any) => {
      const progression: number = e?.detail?.totalProgress || 0 * 100;
    });
    this.modelViewer?.nativeElement.addEventListener('ar-status', (e) => {
      console.log('[Model-Viewer-Artefacto] ar-status', e);
    });
    this.modelViewer?.nativeElement.addEventListener('ar-tracking', (e) => {
      console.log('[Model-Viewer-Artefacto] ar-tracking', e);
    });
    this.modelViewer?.nativeElement.addEventListener(
      'quick-look-button-tapped',
      (e) => {
        console.log('[Model-Viewer-Artefacto] quick-look-button-tapped', e);
      }
    );
  }

  ngOnInit(): void {
    console.log(`[Model-Viewer-Artefacto] Model-viewer-artefacto loading...`);
    this.enabled = true;

    // Display errors
    if (!this.modelFilePath) {
      this.errorMessages.push('No model file path given');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(`Change detected on model-viewer-artefacto:`, changes);
    if (changes['forceAr'] && !changes['forceAr']?.firstChange) {
      if (this.forceAr) {
        console.log('[Model-Viewer-Artefacto] Activate AR...');
        this.modelViewerArtefactoService.activateAr()?.then(
          (res) => {
            console.log('[Model-Viewer-Artefacto] AR activated', res);
          },
          (err) => {
            console.error('[Model-Viewer-Artefacto] AR activation failed', err);
          }
        );
        
      }
    }
    if (changes['variant-name'] && !changes['variant-name']?.firstChange) {
    }
  }

  // When model3d is loaded
  private onModel3dLoaded() {
    console.log(`[Model-Viewer-Artefacto] Model-viewer-artefacto loaded`);
    this.modelViewerArtefactoService.setModelViewerInstance(
      this.modelViewer?.nativeElement
    );

    this.modelLoaded.emit(true);

    this.canActivateAr.emit(this.modelViewer?.nativeElement.canActivateAR);

    if (this.forceAr) {
      const a = this.modelViewerArtefactoService.activateAr();
      console.log('Activate AR', a);
    }
  }
}
